import { array, boolean, defineAction, object, string } from '~/prix'
import systemExportPostgresDumpAction from './systemExportPostgresDump.action.json'

const systemExportPostgresDumpDefinition = defineAction({
  ...systemExportPostgresDumpAction,
  input: object({
    table: string(),
    tableList: array(string()),
    schema: string(),
    force: boolean(),
  }),
  output: object({}),
})

export default systemExportPostgresDumpDefinition
